import {Component} from '@angular/core';
/**
 * \@title Input hints
 */
export class InputHintExample { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'input-hint-example',
  templateUrl: 'input-hint-example.html',
  styleUrls: ['input-hint-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputHintExample_tsickle_Closure_declarations() {
/** @type {?} */
InputHintExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputHintExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
